<!-- Overlay loading -->
<app-fullscreen-overlay
  [isOverlayLoading]="isOverlayLoading"
></app-fullscreen-overlay>

<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1"
                >{{
                  surveyCode
                    ? ("createSurvey" | translate)
                    : questionAddOptionId
                    ? ("addQuestion" | translate)
                    : ("editQuestion" | translate)
                }}
                {{ applicationTitle }}
                {{
                  surveyCode ? ("survey" | translate) : ("question" | translate)
                }}</span
              >
            </h3>
          </div>
          <div class="card-body pt-3 pb-4">
            <form [formGroup]="saveSurveyForm" (ngSubmit)="onSubmit()">
              <div class="row align-items-center mb-8">
                <!-- Survey Name -->
                <div *ngIf="surveyCode" class="col-md-3">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="name"
                    id="surveyName"
                    placeholder="{{ 'enterSurveyName' | translate }}"
                  />
                </div>
                <!-- Device Utilization -->
                <div *ngIf="surveyCode" class="col-md-2">
                  <select
                    class="form-select cursor-pointer"
                    formControlName="hasDeviceUtilization"
                  >
                    <option [ngValue]="null" disabled>
                      {{ "deviceUtilization" | translate }}
                    </option>
                    <option value="true">
                      {{ "yes" | translate }}
                    </option>
                    <option value="false">
                      {{ "no" | translate }}
                    </option>
                  </select>
                </div>
                <!-- Add New Question Button -->
                <div
                  *ngIf="!checkDeviceUtilization"
                  class="text-end"
                  [ngClass]="surveyCode ? 'col-md-7' : 'col-md-12'"
                >
                  <a
                    (click)="addQuestion()"
                    class="btn btn-sm fw-bold btn-primary"
                    >{{ "addNewQuestion" | translate }}</a
                  >
                </div>
              </div>

              <!-- Questions Section -->
              <div *ngIf="!checkDeviceUtilization" formArrayName="questions">
                <div
                  *ngFor="
                    let question of questions.controls;
                    let i = index;
                    let isLast = last
                  "
                  [formGroupName]="i"
                >
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <input
                        type="text"
                        class="form-control"
                        formControlName="text"
                        placeholder="{{ 'enterQuestion' | translate }}"
                      />
                    </div>
                    <div class="col-md-2">
                      <select
                        class="form-select cursor-pointer"
                        formControlName="answerType"
                      >
                        <option value="0" selected disabled>
                          {{ "selectAnswerType" | translate }}
                        </option>
                        <option
                          *ngFor="let answerType of answerTypes"
                          [value]="answerType.id"
                        >
                          {{ answerType.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <a
                        (click)="removeQuestion(i)"
                        class="delete btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                        ><i class="fa-solid fa-xmark"></i
                      ></a>

                      <a
                        *ngIf="questions.at(i).get('answerType')?.value == 1"
                        (click)="addAnswerOption(i)"
                        class="delete btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer ms-3"
                        ><i class="fa-solid fa-plus"></i
                      ></a>
                    </div>
                  </div>

                  <!-- Answer Options -->
                  <div
                    *ngIf="questions.at(i).get('answerType')?.value == 1"
                    formArrayName="answerOptions"
                    class="col-md-12 mt-4"
                  >
                    <label
                      *ngIf="getAnswerOptions(i).controls?.length"
                      class="mb-2"
                      >{{ "answerOptions" | translate }}</label
                    >
                    <div
                      *ngFor="
                        let option of getAnswerOptions(i).controls;
                        let j = index
                      "
                      [formGroupName]="j"
                      class="row align-items-center mb-3"
                    >
                      <div class="col-md-6">
                        <input
                          type="text"
                          class="form-control"
                          formControlName="answerText"
                          placeholder="{{ 'enterAnswerOption' | translate }}"
                        />
                      </div>
                      <div class="col-md-2">
                        <input
                          type="number"
                          class="form-control"
                          formControlName="score"
                          placeholder="{{ 'score' | translate }}"
                        />
                      </div>
                      <div class="col-md-1">
                        <a
                          (click)="removeAnswerOption(i, j)"
                          class="delete btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                          ><i class="fa-solid fa-xmark"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                  <hr *ngIf="!isLast" class="my-6" />
                </div>
              </div>

              <!-- Submit Button -->
              <div class="d-flex justify-content-end mt-8 gap-3">
                <button
                  [routerLink]="['/survey/list']"
                  type="button"
                  class="btn btn-sm btn-secondary cursor-pointer"
                >
                  {{ "cancel" | translate }}
                </button>
                <button
                  type="submit"
                  class="btn btn-sm btn-dark cursor-pointer"
                >
                  {{ "save" | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
